module.exports = __webpack_public_path__ + "static/img/iconmenu01.2c2453dc.svg";